<!--  -->
<template>
  <div>
    <div class="select_box">
      <div>
        <div class="outerLayer_groupingArea">
          <div class="left">
            <span class="left_title">是否公用</span>
            <ul class="left_ul">
              <li class="ul_li" :class="{active:pageIfon.is_public == 1}" @click="lewrurl(1)">否</li>
              <li class="ul_li" :class="{active:pageIfon.is_public == 2}" @click="lewrurl(2)">是</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
        <div class="outerLayer_groupingArea" style="margin:15px 0px">
          <div class="left">
            <span class="left_title">图片类型</span>
            <ul class="left_ul">
              <li
                v-for="itemr,index in typelist"
                :key="index"
                :class="{active:pageIfon.business_type == itemr.type}"
                class="ul_li"
                @click="wrw(itemr.type)"
              >{{ itemr.name }}</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
      </div>
      <div>
        <el-upload
          ref="upload"
          class="upload-demo"
          :file-list="fileList"
          action="#"
          :on-success="handleAvatarSuccess"
          :http-request="httpRequest"
          :before-upload="beforeAvatarUpload"
          :on-remove="handleRemove"
          :multiple="true"
          :on-change="handleChange"
          :show-file-list="false"
          :limit="100"
        >
          <el-button
            size="small"
            type="primary"
            plain
          >点击上传</el-button>
        </el-upload>
      </div>
    </div>

    <div v-if="imgarrs.length!=0" class="imgbox">
      <div v-for="(item,index) in imgarrs" :key="index" class="imgboxew">
        <img :src="item.path" class="item-img" @click="handitem(item.path,item.id)">
      </div>
    </div>
    <div v-else class="zanewr">暂无数据</div>

    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>

</template>

<script>
import { getMaterialLibraryList, materialroadtype } from '@/api/sourceMaterial.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { uploadFilesimg } from '@/utils/ObjectStorage'
import { getQcConfig, storeBatchQc } from '@/api/sourceminiprogram'
export default {
  components: {
    PaginationRight
  },
  mixins: [getNowDate],
  props: {
    imgarr: {
      type: Array,
      default: () => {
        return []
      }
    }

  },
  data() {
    return {
      imgarrs: [],
      typer: null,
      total: null,
      pageIfon: {
        type: 1,
        page: 1,
        pageSize: 10,
        is_public: 1,
        business_type: 0
      },
      typelist: [],
      token: null,
      temporary: null,
      fileList: []
    }
  },
  created() {
    this.mawlist()
  },
  mounted() {

  },
  methods: {
    // 获取素材库类型列表
    async mawlist() {
      const data = await materialroadtype()
      this.typelist = data.data
      console.log('类型data', data)
    },
    // 获取素材库列表
    getlist() {
      getMaterialLibraryList(this.pageIfon).then(res => {
        console.log('res', res)
        this.imgarrs = res.data.list
        this.total = res.data.total
      })
    },
    handitem(img, key) {
      if (this.typer === '1') {
        console.log('111')
        this.$emit('clickicon', img, key)
      } else if (this.typer === '2') {
        console.log('222')
        this.$emit('kefuicon', img, key)
      } else {
        console.log('333')
        this.$emit('imgcallback', img, key)
      }
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getlist()
    },
    lewrurl(id) {
      this.pageIfon.page = 1
      this.pageIfon.is_public = id
      this.getlist()
    },
    wrw(id) {
      this.pageIfon.page = 1
      this.pageIfon.business_type = id
      this.getlist()
    },
    handleAvatarSuccess(res, file) {
      console.log('res, fil=====e:', res, file)
    },
    async httpRequest(e) {
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const arr = []
      const img = new Image()
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options)
            arr.push({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: res.files[0].options.Key
            })
            setTimeout(async() => {
              await storeBatchQc({ list: arr, business_type: _this.pageIfon.business_type, is_public: this.pageIfon.is_public })
              await this.getlist()
              this.temporary = null
            }, 500)
            _this.showProgress = false
            this.percentage = 0
            this.getlist()
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    },
    beforeAvatarUpload(file) {
      this.uploadFile = file
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleChange(file, fileList) {
      console.log(1)
      this.uploadedVideoshow = false
      this.uploadedVideoCount++
      this.imgloding = false
      fileList.forEach(info => {
        // eslint-disable-next-line eqeqeq
        // if (file.uid != info.uid) {
        //   this.deletefile(info.raw)
        // }
      })

      if (fileList.length > 0) {
        const existingUIDs = this.fileList.map(info => info.uid)
        const processedFiles = fileList.map(info => {
          return {
            ...info,
            name: info.name && info.name.replace(/\s/g, '') // 名字去除空格
          }
        })
        const newFiles = processedFiles.filter(info => !existingUIDs.includes(info.uid))
        this.fileList.push(...newFiles)
      }
    },
    async getconfig() {
      const res = await getQcConfig()
      // console.log('res.data.ciphertext:', res.data.ciphertext)
      // const decodedString = atob(res.data.upToken)
      // console.log('decodedString:', decodedString)
      this.config = res.data
    },
    parentHandleclick(e) {
      console.log(e)
      this.typer = e
      this.getlist()
      // this.getQiniuToken()
      this.getconfig()
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
*{

  list-style-type: none;
  box-sizing: border-box;
}
.active{
  border: 1px solid #67C23A;
  color: #67C23A;
}
   .outerLayer_groupingArea{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
        .left{
          display: flex;
          align-items: center;
           .left_title{
              font-size: 14px;
           }
           .left_ul{
             display: flex;
             align-items: center;
             .ul_li{
              list-style-type:none;
              // padding: 6px 10px;
              padding: 7px 10px 5px 10px;
              font-size: 13px;
              cursor: pointer;
              border-radius: 6px;
              &:not(.active):hover{
               background-color: rgb(230, 230, 230);
              }
              .active{
                background-color: rgb(202, 202, 202);
              }
             }
           }
        }
        .right{
           .right_span{
             font-size: 12px;
             padding: 6px 10px;
             border-radius: 5px;
             display: inline-block;
             cursor: pointer;
             &:hover{
               background-color: rgb(230, 230, 230);
             }
           }
        }
   }
.imgbox{
  display: flex;
  flex-wrap: wrap;
}
.item-img{
 width: 150px;
 height: 150px;
 margin-right: 15px;
}
.imgboxew{
  width: 150px;
  height: 150px;
  margin-right: 20px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
}
.zanewr{
  text-align: center;
  margin: 10px 0px;
}
.select_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 80px;
}
  @media (max-width: 768px){
    .upload-demo{
      top: 90px !important;
      position: absolute !important;
      right: 15vw !important;
    }
  }
</style>
